import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { SvgIconHandler } from "../svg-icon-hadler";
import "./toast.m.css";

export const Toast = ({ status = "success", message, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    onClose(isVisible);
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    isVisible && (
      <div styleName={`toast ${status}`} id="toast">
        <div styleName="icon">
          <SvgIconHandler type={`${status === "success" ? "toast-info" : "toast-error"}`} width="24" height="24" />
        </div>
        <div styleName="message">{message}</div>
        <div styleName="separator"></div>
        <button styleName="undo-btn" onClick={handleClose}>
          Close
        </button>
      </div>
    )
  );
};

Toast.propTypes = {
  status: PropTypes.oneOf(["success", "failure"]),
  message: PropTypes.string,
  onClose: PropTypes.func,
};
